// ledgerPrefixes — 台帳が自前で採番しているプレフィックスをバックエンドから受け取る。
//
// 20260610 · 正本は `backend/ledger_counters.py`（実際の採番コードの隣）。
// フロント側に一覧をハードコードすると、台帳が増えた時に必ずドリフトする
// （Round 2 で削除した `ledgerCategories.js` と同じ失敗）。ここは取得とキャッシュ
// だけを行い、判断材料は API から来たものしか使わない。
//
// hard_locked=true のプレフィックスだけを UI でブロックする。それ以外の衝突は
// 設定 → 品番マスター の衝突レポートに出すだけ（既存の正当なフローを黙って
// 壊さないため、ロック対象はバックエンド側の宣言に従う）。
import { useEffect, useState } from 'react';
import axios from 'axios';
import { skuTemplatePrefix } from './skuDisplay';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = { rows: [], locked: new Set() };
let cache = null;

export function loadLedgerCounters({ force = false } = {}) {
  if (!cache || force) {
    cache = axios.get(`${API}/sku/ledger-counters`, { withCredentials: true })
      .then((r) => ({
        rows: r.data?.rows || [],
        locked: new Set(r.data?.hard_locked_prefixes || []),
      }))
      .catch(() => { cache = null; return EMPTY; });
  }
  return cache;
}

// 最長一致で所有台帳を引く（`EQP` は `EQ` にも前方一致するため）。
export function ledgerRowFor(prefix, rows) {
  if (!prefix) return null;
  for (let len = prefix.length; len > 1; len -= 1) {
    const hit = (rows || []).find((r) => r.prefix === prefix.slice(0, len));
    if (hit) return hit;
  }
  return null;
}

// 台帳がロックしているルールなら { row, note } を返す。そうでなければ null。
export function ledgerLockFor(tpl, state) {
  const row = ledgerRowFor(skuTemplatePrefix(tpl), state?.rows);
  if (!row || !row.hard_locked) return null;
  return { row, note: `${row.owner_label}が採番します` };
}

export async function filterLedgerLocked(templates) {
  const state = await loadLedgerCounters();
  return (templates || []).filter((t) => !ledgerLockFor(t, state));
}

export function useLedgerCounters() {
  const [state, setState] = useState(EMPTY);
  useEffect(() => {
    let alive = true;
    loadLedgerCounters().then((s) => { if (alive) setState(s); });
    return () => { alive = false; };
  }, []);
  return state;
}
